import { Component, ElementRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { APP_ENV_CONFIG } from '@shared/services';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  envConfig = inject(APP_ENV_CONFIG);

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    if (['develop', 'qa'].includes(this.envConfig.name)) {
      this.elementRef.nativeElement.removeAttribute('ng-version');
    }
  }
}
